import React from 'react'

import { css } from '@emotion/react'

import Sidebar from '@microsites/components/AppLayout/Sidebar'
import { Container } from '@microsites/components/Container/Container'

import { propWithBreakpoints } from '../MediaQuery'

/**
 * Default app layout component rendered as parent of every PWA page
 */
export default function AppLayout({ children }) {
  return (
    <div id="cy-root">
      <div
        css={css`
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-image: radial-gradient(
            circle at 50% 0,
            rgba(255, 255, 255, 0.3),
            rgba(255, 255, 255, 0) 75%
          );
          pointer-events: none;
        `}
      />
      <Container
        css={[
          css`
            display: flex;
          `,
          propWithBreakpoints('padding-bottom', [
            'env(safe-area-inset-bottom)',
            0,
          ]),
        ]}
      >
        <Sidebar />
        <div
          css={css`
            flex: 1;
            position: relative;
          `}
        >
          {children}
        </div>
      </Container>
    </div>
  )
}
